export default {
	methods: {
		startAgent(proxy){
			Object.keys(this.$listeners).forEach(name => proxy.on(name, this.$listeners[name]))
		},
		stopAgent(proxy){
			Object.keys(this.$listeners).forEach(name => proxy.off(name, this.$listeners[name]))
		}
	},
}